const getOfferTireKey = (offer, index = 0) => {
  const tire = offer?.tire;

  if (typeof tire === "object" && tire?.id) {
    return String(tire.id);
  }

  if (tire) {
    return String(tire);
  }

  return `__offer_without_tire__${index}`;
};

export const getOffersTotalWheelQuantity = (offers = []) => {
  const quantitiesByTire = new Map();

  offers.forEach((offer, index) => {
    const quantity = Number(offer?.wheels_quan ?? offer?.quantity ?? 0);
    if (quantity <= 0) {
      return;
    }

    const tireKey = getOfferTireKey(offer, index);
    if (!quantitiesByTire.has(tireKey)) {
      quantitiesByTire.set(tireKey, quantity);
    }
  });

  if (!quantitiesByTire.size) {
    return 0;
  }

  return Array.from(quantitiesByTire.values()).reduce(
    (sum, quantity) => sum + quantity,
    0
  );
};

export const buildOfferWheelQuantityMap = (offers = [], totalQuantity = 1) => {
  const normalizedTotalQuantity = Math.max(1, Number(totalQuantity || 1));
  const tireKeys = [];

  offers.forEach((offer, index) => {
    const tireKey = getOfferTireKey(offer, index);
    if (!tireKeys.includes(tireKey)) {
      tireKeys.push(tireKey);
    }
  });

  if (!tireKeys.length) {
    return new Map();
  }

  const baseQuantity = Math.floor(normalizedTotalQuantity / tireKeys.length);
  const remainder = normalizedTotalQuantity % tireKeys.length;

  return new Map(
    tireKeys.map((tireKey, index) => [
      tireKey,
      baseQuantity + (index < remainder ? 1 : 0),
    ])
  );
};

export const getOfferWheelQuantityByTire = (
  offer,
  quantityMap,
  index = 0
) => {
  const tireKey = getOfferTireKey(offer, index);
  return quantityMap.get(tireKey) ?? 1;
};
